import { FONT_FACE_DAGNY_DISPLAY, FONT_FACE_DAGNY_TEXT, FONT_FACE_NITTI_GROTESK_NN_HEADING, FONT_FACE_NITTI_GROTESK_NN_TEXT_BOLD, FONT_FACE_NITTI_GROTESK_NN_TEXT_MEDIUM, FONT_FACE_NITTI_GROTESK_NN_TEXT_REGULAR, } from './constants';
export default function getFontPaths() {
    return {
        ttf: {
            [FONT_FACE_DAGNY_DISPLAY]: getPath(require('../src/fonts/ttf/NNDagnyDisplayCompPro.ttf')),
            [FONT_FACE_DAGNY_TEXT]: getPath(require('../src/fonts/ttf/NNDagnyTextComp.ttf')),
            [FONT_FACE_NITTI_GROTESK_NN_HEADING]: getPath(require('../src/fonts/ttf/NittiGroteskNN-Heading-1.2.ttf')),
            [FONT_FACE_NITTI_GROTESK_NN_TEXT_REGULAR]: getPath(require('../src/fonts/ttf/NittiGroteskNN-TextRegular-1.2.ttf')),
            [FONT_FACE_NITTI_GROTESK_NN_TEXT_MEDIUM]: getPath(require('../src/fonts/ttf/NittiGroteskNN-TextMedium-1.2.ttf')),
            [FONT_FACE_NITTI_GROTESK_NN_TEXT_BOLD]: getPath(require('../src/fonts/ttf/NittiGroteskNN-TextBold-1.2.ttf')),
        },
        woff: {
            // Map web to comp.
            [FONT_FACE_DAGNY_DISPLAY]: getPath(require('../src/fonts/woff/NNDagnyDisplayWebPro.woff')),
            // Map web to comp.
            [FONT_FACE_DAGNY_TEXT]: getPath(require('../src/fonts/woff/NNDagnyTextWeb.woff')),
            [FONT_FACE_NITTI_GROTESK_NN_HEADING]: getPath(require('../src/fonts/woff/NittiGroteskNN-Heading-1.2.woff')),
            [FONT_FACE_NITTI_GROTESK_NN_TEXT_REGULAR]: getPath(require('../src/fonts/woff/NittiGroteskNN-TextRegular-1.2.woff')),
            [FONT_FACE_NITTI_GROTESK_NN_TEXT_MEDIUM]: getPath(require('../src/fonts/woff/NittiGroteskNN-TextMedium-1.2.woff')),
            [FONT_FACE_NITTI_GROTESK_NN_TEXT_BOLD]: getPath(require('../src/fonts/woff/NittiGroteskNN-TextBold-1.2.woff')),
        },
        woff2: {
            [FONT_FACE_DAGNY_DISPLAY]: getPath(require('../src/fonts/woff2/NNDagnyDisplayCompPro.woff2')),
            [FONT_FACE_DAGNY_TEXT]: getPath(require('../src/fonts/woff2/NNDagnyTextComp.woff2')),
            [FONT_FACE_NITTI_GROTESK_NN_HEADING]: getPath(require('../src/fonts/woff2/NittiGroteskNN-Heading-1.2.woff2')),
            [FONT_FACE_NITTI_GROTESK_NN_TEXT_REGULAR]: getPath(require('../src/fonts/woff2/NittiGroteskNN-TextRegular-1.2.woff2')),
            [FONT_FACE_NITTI_GROTESK_NN_TEXT_MEDIUM]: getPath(require('../src/fonts/woff2/NittiGroteskNN-TextMedium-1.2.woff2')),
            [FONT_FACE_NITTI_GROTESK_NN_TEXT_BOLD]: getPath(require('../src/fonts/woff2/NittiGroteskNN-TextBold-1.2.woff2')),
        },
    };
}
/**
 * Depending on the application's build, the file loader resolves CommonJS or ESModule.
 * Handle both scenarios.
 */
function getPath(input) {
    if (typeof input === 'string') {
        return input;
    }
    return input.default;
}
